var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"py-15",attrs:{"id":"clientes"}},[_c('TitleWidget',[_vm._v("Clientes")]),(_vm.items && _vm.items.length)?_c('CarouselWidget',{staticClass:"carousel-clientes",attrs:{"items":_vm.items,"itemsToShow":{
      xs: 2,
      sm: 3,
      md: 4,
      lg: 5,
      xl: 5,
    },"gap":20,"nav":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
    var item = ref.item;
return [_c('v-sheet',{staticClass:"py-5 px-5 my-5 rounded-lg",attrs:{"elevation":"2"}},[_c('img',{staticClass:"img-logo",attrs:{"src":_vm.files + item.path + '?resize=1&h=100'}})])]}}],null,false,3828208440)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }